












/** @format */

import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GANG_STOP } from '../router-names';
import AddEditGangStop from './components/add-edit-gang-stop.vue';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddEditGangStop }
})
export default class GangStopCreate extends Vue {
  path = '/smart-parking/parking-lot-management/gang-stop/';
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  // 外部传入车场id
  @Prop({ type: String, default: '' })
  parkId!: string;
  headTitle = '新增岗亭'; // 标题
  dataForm = null; //通道表单数据，编辑回填
  channelId = '';
  isEdit: boolean = false;
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '岗亭信息',
        location: {
          name: GANG_STOP
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: GANG_STOP
    });
  }
}
